var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',{staticClass:"elevation-1 mt-4"},[_c('ProductsTableList')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }